/* eslint-disable @typescript-eslint/no-explicit-any */
import classes from './CellProductionsActions.module.css';
import { Box, rem, Image } from '@mantine/core';
import { Menu, ActionIcon } from '@mantine/core';
import IconDotsVertical from '@assets/icons/dots-vertical.svg';
import IconExternalLink from '@assets/icons/external-link.svg';

import {
	IconTrash,
	IconPlayerPlay,
	IconCheck,
	IconX,
} from '@tabler/icons-react';
import styles from './CellProductionsActions.module.css';
import { useTranslation } from 'react-i18next';
import { ROLES } from '@config/constants/roles';
import { useAuthorization } from '@lib/authorization';
import { ACLS } from '@config/constants/acls';

export const CellProductionsActions = (props: {
	onViewMore?: (data: any) => void;
	onVerify?: (data: any) => void;
	onMint?: (data: any) => void;
	onDelete?: (data: any) => void;
	row: any;
	opened?: boolean;
}) => {
	const { t } = useTranslation();
	const { checkRole, checkAcl } = useAuthorization();
	return (
		<Box
			style={{
				display: 'flex',
				width: '26px',
				height: '25px',
			}}
		>
			<Menu
				opened={props.opened}
				shadow="xs"
				classNames={styles}
			>
				<Menu.Target>
					<ActionIcon
						data-testid="W2FtAER5_Z5jdHi6B-menu"
						variant="transparent"
						className={classes.customSize}
						onClick={(event) => {
							event.stopPropagation();
						}}
					>
						<Image
							style={{
								objectFit: 'contain',
								width: rem(25),
								height: rem(25),
							}}
							src={IconDotsVertical}
						/>
					</ActionIcon>
				</Menu.Target>
				<Menu.Dropdown>
					<Menu.Item
						data-testid="W2FtAER4_Z5jdHi6B-menu"
						onClick={(event) => {
							event.stopPropagation();
							if (props && props.row) {
								props.onViewMore!(props.row);
							}
						}}
						color="var(--mantine-color-black)"
						className={styles.item}
						leftSection={
							<Image
								style={{
									objectFit: 'contain',
									width: rem(20),
									height: rem(20),
								}}
								src={IconExternalLink}
							/>
						}
					>
						{t('global.viewMore')}
					</Menu.Item>
					{checkRole([
						ROLES.ADMIN,
						ROLES.SUPERADMIN,
						ROLES.STAFF,
					]) &&
						checkAcl(ACLS.PRODUCTIONS.ADMIN) && (
							<Menu.Item
								data-testid="W2FtAER3_Z5jdHi6B-menu"
								disabled={props.row?.aco2Token}
								onClick={(event) => {
									event.stopPropagation();
									if (props && props.row) {
										props.onVerify!(props.row);
									}
								}}
								color="var(--mantine-color-black)"
								className={styles.item}
								leftSection={
									!props.row?.verified ? (
										<IconCheck
											style={{
												width: rem(20),
												height: rem(20),
											}}
										/>
									) : (
										<IconX
											style={{
												width: rem(20),
												height: rem(20),
											}}
										/>
									)
								}
							>
								{!props.row?.verified
									? t('global.verify')
									: t('global.unverify')}
							</Menu.Item>
						)}
					{checkRole([
						ROLES.ADMIN,
						ROLES.SUPERADMIN,
						ROLES.STAFF,
					]) &&
						checkAcl(ACLS.PRODUCTIONS.ADMIN) && (
							<Menu.Item
								data-testid="W2FtAER2_Z5jdHi6B-menu"
								disabled={
									!props.row?.verified ||
									props.row?.aco2Token
								}
								onClick={(event) => {
									event.stopPropagation();
									props.onMint!(props.row);
								}}
								color="var(--mantine-color-black)"
								className={styles.item}
								leftSection={
									<IconPlayerPlay
										style={{
											width: rem(20),
											height: rem(20),
										}}
									/>
								}
							>
								{t('global.mint')}
							</Menu.Item>
						)}

					{checkRole([
						ROLES.ADMIN,
						ROLES.SUPERADMIN,
						ROLES.STAFF,
					]) &&
						checkAcl(ACLS.PRODUCTIONS.ADMIN) && (
							<Menu.Item
								data-testid="W2FtAER1_Z5jdHi6B-menu"
								disabled={props.row?.verified}
								onClick={(event) => {
									event.stopPropagation();
									if (props && props.row) {
										props.onDelete!(props.row);
									}
								}}
								className={styles.item}
								color="red"
								leftSection={
									<IconTrash
										style={{
											width: rem(20),
											height: rem(20),
										}}
									/>
								}
							>
								{t('global.delete')}
							</Menu.Item>
						)}
				</Menu.Dropdown>
			</Menu>
		</Box>
	);
};
